import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import ProtectedRoute from './components/ProtectedRoute';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import UserHeader from './components/UserHeader';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Flights from './pages/Flights';
import FlightDetail from './pages/FlightDetail';
import Callback from './pages/Callback';
import SensorOrderDetail from './pages/SensorOrderDetail';
import News from './pages/News';
import NewsDetail from './pages/NewsDetail';
import Settings from './pages/Settings';
import AllFlights from './pages/AllFlights';
import PublicFlightDetail from './pages/PublicFlightDetail';
import Friends from './pages/Friends';
import PilotProfile from './pages/PilotProfile';
import './App.css';

function AppContent() {
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  // Show sidebar only on protected routes when authenticated
  const showSidebar = isAuthenticated &&
    !['/login', '/register', '/callback'].includes(location.pathname);

  return (
    <>
      <Header />
      <div style={{ display: 'flex' }}>
        {showSidebar && <Sidebar />}
        <div style={{ flex: 1 }}>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/callback" element={<Callback />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/flights"
              element={
                <ProtectedRoute>
                  <Flights />
                </ProtectedRoute>
              }
            />
            <Route
              path="/flights/:id"
              element={
                <ProtectedRoute>
                  <FlightDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/sensor-orders/:orderId"
              element={
                <ProtectedRoute>
                  <SensorOrderDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/friends"
              element={
                <ProtectedRoute>
                  <Friends />
                </ProtectedRoute>
              }
            />
            <Route
              path="/pilots/:userid"
              element={
                <ProtectedRoute>
                  <PilotProfile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/all-flights"
              element={
                <ProtectedRoute>
                  <AllFlights />
                </ProtectedRoute>
              }
            />
            <Route
              path="/all-flights/:id"
              element={
                <ProtectedRoute>
                  <PublicFlightDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/news"
              element={
                <ProtectedRoute>
                  <News />
                </ProtectedRoute>
              }
            />
            <Route
              path="/news/:id"
              element={
                <ProtectedRoute>
                  <NewsDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/logbook"
              element={
                <ProtectedRoute>
                  <div className="container" style={{ padding: '40px' }}>
                    <UserHeader title="Fahrtenbuch" />
                    <p>Coming soon...</p>
                  </div>
                </ProtectedRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <ProtectedRoute>
                  <Settings />
                </ProtectedRoute>
              }
            />
            <Route
              path="/about"
              element={
                <ProtectedRoute>
                  <div className="container" style={{ padding: '40px' }}>
                    <UserHeader title="Über das Projekt" />
                    <p>Coming soon...</p>
                  </div>
                </ProtectedRoute>
              }
            />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </div>
      </div>
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <NotificationProvider>
        <Router basename={process.env.PUBLIC_URL}>
          <AppContent />
        </Router>
      </NotificationProvider>
    </AuthProvider>
  );
}

export default App;
